import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['note', 'toggleIcon'];

  noteTargetConnected(element) {
    let candidate = element.previousElementSibling;
    for (var attempts = 0; attempts < 3; attempts++) {
      if (candidate.nodeName == 'P') break;
      if (candidate.previousElementSibling == null) break;

      candidate = candidate.previousElementSibling;
    }

    if (candidate !== null) {
      const node = element.querySelector('.js-toggle-icon');
      candidate.appendChild(node);
    } else {
      element.classList.add('hidden');
    }
  }

  toggle(event) {
    const toggleIconContainer = event.currentTarget.parentNode;
    let nextAuthorNote = toggleIconContainer.nextElementSibling;

    for (var attempts = 0; attempts < 3; attempts++) {
      if (nextAuthorNote.classList.contains('js-author-note')) break;
      if (nextAuthorNote.nextElementSibling == null) break;

      nextAuthorNote = nextAuthorNote.nextElementSibling;
    }

    if (nextAuthorNote !== null) {
      nextAuthorNote.classList.toggle('hidden');
    }
  }
}
